<template lang="pug">
.select-card-group
  .cards
    template(v-for="(item, index) in items")
      .card-item(@click="active = index")
        SelectCard(
          :item="item",
          :active="active === index",
          @click.native="cardInfo = item",
          :loading="loading"
        )
        .mark-container(:class="{active: active===index}")
          .mark
            img(src="https://m.hellobike.com/resource/helloyun/07177/gygQRzhtfS.png?x-oss-process=image/quality,q_80")
      .divider(v-if="index!=items.length-1")
  .btn.flex-mid(@click="sure") 确认选择
  FlexModal(
    :title="modalTitle",
    ref="modal",
    sub-btn-text="再想想",
    btn-text="领取",
    @cancel="cancel",
    @close="close",
    @confirm="confirm",
    color="#DD4C47"
  )
    .modal-text(slot="body")
      span 选择后不可以更换哦~
</template>

<script>
import FlexModal from '@/components/flex-modal';
import SelectCard from './select-card.vue';

export default {
  components: {
    SelectCard,
    FlexModal,
  },
  props: {
    items: {
      type: Array,
      default: null,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    current() {
      if (this.active === null) {
        return null;
      }
      return this.items[this.active] || null;
    },
    modalTitle() {
      if (!this.current) {
        return '选择此券吗？';
      }
      let body = this.current.title;
      if (this.current.num && this.current.num > 1) {
        body = `${this.current.num}张${body}`;
      }
      return `选择${body}吗？`;
    },
    cardInfo: {
      get() {
        // 获取默认的卡片信息
        return this.items[this.active] || {};
      },
      set(newV) {
        if (typeof newV !== 'object') {
          return {};
        }
        return newV;
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    cancel() {},
    close() {},
    sure() {
      if (this.loading) {
        return;
      }
      this.$refs.modal.open();
    },
    async confirm() {
      this.$emit('ok', this.cardInfo);
    },
  },
};
</script>
<style lang="less" scoped>
.select-card-group {
  .btn {
    width: 100%;
    height: 0.4rem;
    background: #dd4c47;
    border-radius: 0.2rem;
    font-size: 0.16rem;
    font-weight: 500;
    color: #fff;
    margin-top: 0.16rem;
  }

  .divider {
    width: 0.19rem;
    height: 1px;
  }

  .cards {
    display: flex;
    justify-content: space-between;
  }

  .card-item {
    flex: 1;
    display: inline-block;
    position: relative;
    // overflow: hidden;

    .mark-container {
      width: 0.32rem;
      height: 0.3rem;
      border-bottom-right-radius: 0.08rem;
      overflow: hidden;
      position: absolute;
      right: 0;
      bottom: 0;

      .mark {
        opacity: 0;
        pointer-events: none;
        box-sizing: content-box;
        position: relative;
        width: 0;
        height: 0;
        // border-bottom-right-radius: 0.08rem;
        border-bottom: #efc36a solid 0.3rem;
        border-left: transparent  solid 0.32rem;

        img {
          transform: translate(40%, 50%);
          width: 0.12rem;
          position: absolute;
          top: 0.11rem;
          left: -0.2rem;
        }
      }

      &.active .mark {
        opacity: 1;
      }
    }
  }
}
</style>
